import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getAustinStructuredData() {
  const url = "https://restorehair.com/locations/texas/austin/";
  const description =
    "Find out about your hair transplant options in Austin with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("austin", url, description),
    locationPageCrumbs(url, "Austin"),
  ];
}
